<template>
    <div id="inspection-container">
        <HeaderComponent id="header"/>
        
        <b-navbar
            id="navbar"
            class="navbar"
            type="dark"
            variant="dark"
            small
        >
            <b-navbar-nav class="container">
                <router-link
                    id="data item"
                    class="nav-item"
                    :class="{ selected: currentPath === '/inspection/data' }"
                    to="/inspection/data"
                >
                Dados
                </router-link>
                <router-link
                    id="quiz"
                    class="nav-item"
                    :class="{ selected: currentPath === '/inspection/quiz' }"
                    to="/inspection/quiz"
                >
                    Questionário
                </router-link>
                <router-link
                    id="photosGrid"
                    class="nav-item"
                    :class="{ selected: currentPath === '/inspection/photos-grid' }"
                    to="/inspection/photos-grid"
                >
                    Fotos
                </router-link>
                <router-link
                    id="inspectorSignature"
                    class="nav-item"
                    :class="{ selected: currentPath === '/inspection/inspector-signature' }"
                    to="/inspection/inspector-signature"
                >
                    Vistoriador
                </router-link>
                <router-link
                    id="clientSignature"
                    class="nav-item"
                    :class="{ selected: currentPath === '/inspection/client-signature' }"
                    to="/inspection/client-signature"
                    
                >
                    Cliente
                </router-link>
                <router-link
                    id="saveInspection"
                    class="nav-item"
                    :class="{ selected: currentPath === '/inspection/save-inspection' }"
                    to="/inspection/save-inspection"
                >
                    Salvar
                </router-link>
            </b-navbar-nav>
        </b-navbar>

        <router-view></router-view>

    </div>
</template>

<script>
import HeaderComponent from "@/components/Header.vue";

import { BNavbar, BNavbarNav } from "bootstrap-vue";
import Swal from "sweetalert2";

export default {
    components: {
        HeaderComponent,
        BNavbar,
        BNavbarNav,
    },
    data: function () {
        return {
            navHeight: null,
            landScape: false,
            headerHeight: null,
        };
    },
    methods: {
        preventPageReload(event) {
            event.preventDefault();
            event.returnValue = "";
        },
    },
    computed: {
        currentPath() {
            return this.$route.path;
        }
    },
    async mounted() {
        window.addEventListener("beforeunload", this.preventPageReload);
        this.navHeight = document.getElementById("navbar").offsetHeight;
        this.headerHeight = document.getElementById("header").offsetHeight;
        this.landScape = window.matchMedia("(orientation: landscape)").matches
            ? true
            : false;

        window.addEventListener("orientationchange", () => {
            this.landScape = window.matchMedia("(orientation: landscape)").matches
                ? false
                : true;
        });

        window.addEventListener("beforeunload", (event) => {
            event.preventDefault();
        });

        if (!this.$store.state.inspectionData.numberPlate) {
            this.$router.push({ path: "/home" });
            return;
        }

        if (
            !this.$store.state.inspectionData.quizType ||
            !this.$store.state.inspectionData.operation
        ) {
            await Swal.fire({
                title: "Erro ao iniciar vistoria",
                text: "Algum erro ocorreu ao carregar os parâmetros iniciais da vistoria!",
                icon: "error",
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Voltar",
            });
            this.$router.push({ path: "/home" });
        }
    },

    beforeDestroy() {
        window.removeEventListener("orientationchange", () => {
            this.landScape = window.matchMedia("(orientation: landscape)").matches
                ? false
                : true;
        });

        window.removeEventListener("beforeunload", this.preventPageReload);
    },
};
</script>

<style scoped>

#inspection-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}


.nav-item {
    color: white !important;
    text-decoration: none !important;
    font-size: 13px;
}

.selected {
    color: rgb(56, 255, 82) !important;
}

.header p {
    margin: 5px 0px;
    font-size: 13px;
    color: white;
}

.header {
    width: 100%;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #49515a;
}

.header .dropdown {
    padding: 10px;
}

.navbar {
    background-color: #343a40;
    overflow: scroll;
    flex-shrink: 0;
    display: flex;
}

.router-link-exact-active {
    text-decoration: none !important;
}

.head {
    color: #a5c4cf;
    display: flex;
    flex-direction: column;
}

.type {
    background-color: #6c757d;
}

/* Iphone 5 */
@media only screen and (max-width: 320px) {
    .nav-item {
        font-size: 10px;
    }
}
</style>
